module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_FB.89edd5bf.svg";